import Icon from "@ant-design/icons";
import React from "react";

export default function AcceptRiskIcon() {
  return <Icon className="ac-icon" component={IconSvg} />;
}

const IconSvg = () => {
  return (
    <svg height="1em" viewBox="0 0 24 24" fill="none">
      <path
        d="M12.7232 7.01807C12.3773 6.32745 11.3917 6.32727 11.0455 7.01776L6.60268 15.8789C6.28984 16.5028 6.74349 17.2377 7.44147 17.2377H11.5543C11.5496 17.7941 11.7763 18.3449 12.2102 18.7377H7.44147C5.62769 18.7377 4.44884 16.828 5.26178 15.2066L9.70459 6.34546C10.6042 4.55115 13.1654 4.55161 14.0644 6.34626L17.4146 13.0344L16.426 14.41L12.7232 7.01807Z"
        fill="currentColor"
      />
      <path
        d="M11.8817 9.4293C12.2959 9.4293 12.6317 9.76509 12.6317 10.1793V11.8676C12.6317 12.2818 12.2959 12.6176 11.8817 12.6176C11.4675 12.6176 11.1317 12.2818 11.1317 11.8676V10.1793C11.1317 9.76509 11.4675 9.4293 11.8817 9.4293Z"
        fill="currentColor"
      />
      <path
        d="M12.6335 13.997C12.6335 13.5828 12.2977 13.247 11.8835 13.247C11.4693 13.247 11.1335 13.5828 11.1335 13.997V14.097C11.1335 14.5112 11.4693 14.847 11.8835 14.847C12.2977 14.847 12.6335 14.5112 12.6335 14.097V13.997Z"
        fill="currentColor"
      />
      <path
        d="M20.5135 13.4347C20.7552 13.0984 20.6785 12.6297 20.3422 12.388C20.0058 12.1462 19.5372 12.2229 19.2954 12.5593L15.547 17.7748L13.9946 16.6494C13.6592 16.4063 13.1903 16.481 12.9472 16.8164C12.7041 17.1518 12.7789 17.6207 13.1142 17.8638L15.2764 19.4312C15.4379 19.5483 15.6393 19.5962 15.8362 19.5644C16.0331 19.5326 16.2092 19.4236 16.3256 19.2617L20.5135 13.4347Z"
        fill="currentColor"
      />
    </svg>
  );
};
